import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import endpoints from "../../config/endpoints";
import { Sidebar } from "../../layouts/Sidebar";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import tools from "../../utils/tools";

const GuaranteeCompanyManage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form, setForm] = useState<any>({});
  const [guarantees, setGuarantees] = useState<any[]>([]);
  const { id: paramId } = useParams();

  const submit = async () => {
    dispatch(setLoading(true));

    const data = tools.extractor(form, ["title", "slug", "description"]);

    const res = await restApi(
      endpoints.guaranteeCompany.basic + (paramId ? "/" + paramId : ""),
    ).post(data);

    if (res.code == 200) {
      Swal.fire({
        title: "موفق",
        text: `شرکت گارانتی با موفقیت ${paramId ? "ویرایش" : "ایجاد"} شد`,
        icon: "success",
        confirmButtonText: "متوجه شدم",
        didClose() {
          navigate("/guaranteeCompany");
        },
      });
    } else {
      Swal.fire({
        title: "ناموفق",
        text: res?.data,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }

    dispatch(setLoading(false));
  };

  const fetchData = async () => {
    if (!paramId) return;

    dispatch(setLoading(true));

    const res = await restApi(endpoints.guaranteeCompany.single + paramId).get();

    if (res.code == 200) {
      setForm({
        title: res.data?.title,
        slug: res.data?.slug,
        description: res.data?.description,
      });
      setGuarantees(res.data?.guarantees || []);
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <main className="dashboardBody">
        <Sidebar />
        <div className="dashBoardMain main">
          <div className="addInfoHeader">
            <div className="buttonContainer keepRight">
              <button
                className="dashboardHeader keepRight"
                onClick={() => submit()}
              >
                <p>{paramId ? "ویرایش" : "ایجاد"} شرکت گارانتی</p>
              </button>
            </div>
            <span>
              <h1 className="sideBarTitle">بازگشت به شرکت های گارانتی</h1>
              <h1 className="dashBoardTitle">
                {paramId ? "ویرایش" : "ایجاد"} شرکت گارانتی
              </h1>
            </span>
            <i className="backAdd" onClick={() => navigate("/guaranteeCompany")} />
          </div>
          <section className="center">
            <div className="AddInfoContainer">
              <label>عنوان</label>
              <input
                className="persianName"
                defaultValue={form?.title}
                onChange={(input) =>
                  setForm((prev) => ({ ...prev, title: input.target.value }))
                }
              />
              <label>اسلاگ</label>
              <input
                className="persianName"
                defaultValue={form?.slug}
                onChange={(input) =>
                  setForm((prev) => ({ ...prev, slug: input.target.value }))
                }
              />
              <label>توضیحات</label>
              <textarea
                className="ShortDiscription"
                defaultValue={form?.description}
                onChange={(input) =>
                  setForm((prev) => ({
                    ...prev,
                    description: input.target.value,
                  }))
                }
              />
              {paramId && guarantees.length > 0 && (
                <>
                  <label className="sideBarTitle">گارانتی ها</label>
                  <table className="listTable">
                    <thead>
                      <tr className="firstTR">
                        <th>عنوان</th>
                        <th>مدت (روز)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {guarantees.map((g) => (
                        <tr key={g.id}>
                          <td>{g.title}</td>
                          <td>{g.days}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default GuaranteeCompanyManage;
